import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { retrieveErrorMessage } from '@common';
import { CONFIG } from '@config';
import posthog from 'posthog-js';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import {
  DEFAULT_POSTHOG_HTTP_ERROR_EVENT,
  POSTHOG_HTTP_ERROR_EVENT_MAPPING,
} from '../../constants/posthog-http-error-event-mapping.constant';

const normalizeUrlForMatching = (url: string): string => {
  const withoutQueryAndHash = url.split('?')[0].split('#')[0];

  if (/^https?:\/\//i.test(withoutQueryAndHash)) {
    try {
      return new URL(withoutQueryAndHash).pathname;
    } catch {
      return withoutQueryAndHash;
    }
  }

  return withoutQueryAndHash;
};

const mapUrlToFailureEventName = (url: string): string => {
  const normalizedUrl = normalizeUrlForMatching(url);

  const matchedMapping = POSTHOG_HTTP_ERROR_EVENT_MAPPING.find(({ pattern }) =>
    pattern.test(normalizedUrl),
  );

  return matchedMapping?.eventName ?? DEFAULT_POSTHOG_HTTP_ERROR_EVENT;
};

export const posthogHttpErrorInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const config = inject(CONFIG);

  return next(request).pipe(
    tap({
      error: (error: HttpErrorResponse) => {
        if (!config.posthog) {
          return;
        }

        const eventName = mapUrlToFailureEventName(request.url);
        posthog.capture(eventName, {
          errorCode: error.status,
          errorMessage: retrieveErrorMessage(error),
          method: request.method,
          url: request.url,
        });
      },
    }),
  );
};
